/** Catalog form shown when dismissing an L1. */
export const DISMISSAL_FORM_ID = typeof __DISMISSAL_FORM_ID__ === 'number' && __DISMISSAL_FORM_ID__ > 0
    ? __DISMISSAL_FORM_ID__
    : 1956;
export const DISMISSAL_FORM_TITLE = typeof __DISMISSAL_FORM_TITLE__ === 'string' && __DISMISSAL_FORM_TITLE__.trim()
    ? __DISMISSAL_FORM_TITLE__
    : 'WA_2_Level 1 Threat Response Dismissal Form';
